# WAS THIS REQUEST ABORTED, OR DID IT FAIL?
#
# Card 6ab2f5400d433c0db46543b3, production CrashLog fingerprint 1061fa4a.
# A child on a Fire tablet left the play screen 419ms after it opened, the
# browser aborted the node fetch that was still in flight, and the rejection
# reached window 'unhandledrejection' — so crash_reporter filed a CrashLog row
# and armed the error boundary's recovery escalation for something that was
# not a failure at all. Nothing in our code aborts a request; the BROWSER
# does, on navigation, reload, or a discarded tab.
#
# The two outcomes want opposite treatment — an abort is swallowed, a real
# answer is shown to the child — so telling them apart is its own decision and
# lives in its own file, where a pin can drive it with the errors axios
# actually constructs rather than with a paraphrase of them.
#
# WHAT AXIOS 1.x BUILDS (node_modules/axios/lib):
#   adapters/xhr.js:111   onabort  -> AxiosError('Request aborted', ECONNABORTED)
#   adapters/xhr.js:144   timeout  -> AxiosError('timeout of …', ECONNABORTED)
#                                     or ETIMEDOUT when clarifyTimeoutError
#   cancel/CanceledError   cancel  -> CanceledError(…, ERR_CANCELED)
#
# SO CODE ALONE IS NOT ENOUGH. An abort and a timeout share ECONNABORTED, and
# a timeout is a REAL failure: the child is still on the screen, still waiting
# for a question that never came, and must be told. The message is what
# separates them, and that is why this is a function and not an `in` test.

# The abort the browser reports through the XHR's own `onabort`.
ABORTED_MESSAGE = /^request aborted$/i

export isAbortedRequest = (err) ->
  return false unless err?
  # An explicit cancellation, however axios spells it. `__CANCEL__` is the
  # brand axios.isCancel() reads, so this answers for a CanceledError without
  # importing axios into the play screen.
  return true if err.code is 'ERR_CANCELED'
  return true if err.__CANCEL__ is true
  # The XHR abort. Guarded on the message because ECONNABORTED is also what a
  # TIMEOUT carries, and a timeout is not this.
  return true if err.code is 'ECONNABORTED' and ABORTED_MESSAGE.test(err.message or '')
  return false
